'use strict';

var React = require('react');
var reactFinalForm = require('react-final-form');
var PropTypes = require('prop-types');
var Form = require('@piconetworks/form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var Date = function Date() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      fieldContainerProps = _ref.fieldContainerProps,
      _ref$previewMode = _ref.previewMode,
      previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
      required = _ref.required,
      rest = _objectWithoutProperties(_ref, ["description", "fieldContainerProps", "previewMode", "required"]);

  var date = typeof window !== 'undefined' ? new window.Date() : null;
  return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Field, fieldContainerProps, /*#__PURE__*/React__default['default'].createElement("p", null, description), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({
    render: function render(field) {
      return /*#__PURE__*/React__default['default'].createElement(Form__default['default'].SingleDate, _extends({
        disabled: previewMode
      }, field, {
        input: Object.assign({}, field.input, {
          value: !field.input.value || Array.isArray(field.input.value) ? date : field.input.value
        })
      }));
    },
    type: "text"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest)));
};

Date.propTypes = {
  description: PropTypes__default['default'].string,
  fieldContainerProps: PropTypes__default['default'].any,
  input: PropTypes__default['default'].any,
  previewMode: PropTypes__default['default'].bool,
  required: PropTypes__default['default'].bool
};

module.exports = Date;
